import { render, staticRenderFns } from "./CookiesBlock.vue?vue&type=template&id=26717244"
import script from "./CookiesBlock.vue?vue&type=script&lang=js"
export * from "./CookiesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports